/**
 * Queue Drawer Component
 * Wraps QueueList in a slide-in Sheet for on-demand queue access
 */

import React, { useCallback } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription
} from '../../ui/sheet';
import QueueList from './QueueList';

const QueueDrawer = ({
  open,
  onOpenChange,
  // QueueList props
  items,
  currentItemId,
  loading,
  onSelect,
  getPriorityColor,
  getStatusColor,
  selectedItems,
  onToggleSelection,
  onSelectAll,
  onClearSelection,
  onDeleteSelected,
  isDeleting
}) => {
  // Auto-close drawer when an item is selected
  const handleSelect = useCallback((itemId) => {
    onSelect(itemId);
    onOpenChange(false);
  }, [onSelect, onOpenChange]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-80 sm:max-w-sm p-0">
        <SheetHeader className="px-4 pt-4 pb-2">
          <SheetTitle className="text-base">Review Queue</SheetTitle>
          <SheetDescription className="text-xs">
            {items.length} item{items.length !== 1 ? 's' : ''} in queue
          </SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-hidden flex flex-col" style={{ height: 'calc(100vh - 80px)' }}>
          <QueueList
            items={items}
            currentItemId={currentItemId}
            loading={loading}
            onSelect={handleSelect}
            getPriorityColor={getPriorityColor}
            getStatusColor={getStatusColor}
            selectedItems={selectedItems}
            onToggleSelection={onToggleSelection}
            onSelectAll={onSelectAll}
            onClearSelection={onClearSelection}
            onDeleteSelected={onDeleteSelected}
            isDeleting={isDeleting}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default QueueDrawer;
